<template>
	<slot></slot>
</template>

<script setup lang="ts">
import {provide, inject, computed} from "vue";
import {RowContext, rowContextKey} from "@fd/containers/agenda/AgendaUtils.ts";
import {isSecured, secureRootKey} from "@t/security/ObjectAccess.ts";
import {pathKey} from "@fd/PartInjectKeys.ts";

const props = defineProps<{
	/** Unique key to identify the row. Useful for rows which do not have primary key yet. */
	itemKey: number|string;
	/** Primary key of the record */
	primaryKey?: string;
	/** Index of the row */
	index: number;

	/** Record object */
	object?: object;
}>();

let contextPath = inject(pathKey, "");

/** Context to identify the row inside this component */
const rowContext = computed<RowContext>(() => {
	return {
		itemKey: props.itemKey,
		primaryKey: props.primaryKey,
		index: props.index,
		object: props.object
	}
});

provide(rowContextKey, rowContext);

// Set the correct error context
provide(pathKey, contextPath + "." + props.index);

if (isSecured(props.object)) {
	provide(secureRootKey, props.object);
}
</script>
